import {lazy, Suspense, useState} from 'react';
import {ThemeProvider} from '@gravity-ui/uikit';
import {AppContext, AppState, loadStateFromLS} from '@app/context/context';
import {createEmitter} from '@app/context/events/events';
import {Route, Routes} from 'react-router-dom';
import {AuthWrapper, Login, PermissionGate} from '@components';
import {ChunkBoundary} from '@frontend/shared';
import {KeyboardNavigationProvider} from '@components/KeyboardNavigation';

const ClientsPage = lazy(() =>
    import('@pages/ClientsPage').then((m) => ({default: m.ClientsPage}))
);
const CrossesPage = lazy(() =>
    import('@pages/CrossesPage').then((m) => ({default: m.CrossesPage}))
);
const HomePage = lazy(() => import('@pages/HomePage').then((m) => ({default: m.HomePage})));
const OrdersPage = lazy(() => import('@pages/OrdersPage').then((m) => ({default: m.OrdersPage})));
const ReportPage = lazy(() => import('@pages/ReportPage').then((m) => ({default: m.ReportPage})));
const SearchPage = lazy(() => import('@pages/SearchPage').then((m) => ({default: m.SearchPage})));
const SearchPageDetails = lazy(() =>
    import('@pages/SearchPageDetails').then((m) => ({default: m.SearchPageDetails}))
);
const SettingsPage = lazy(() =>
    import('@pages/SettingsPage').then((m) => ({default: m.SettingsPage}))
);
const SuggestPage = lazy(() =>
    import('@pages/SuggestPage').then((m) => ({default: m.SuggestPage}))
);
const CallWSPage = lazy(() => import('@pages/CallWSPage').then((m) => ({default: m.CallWSPage})));

const App = () => {
    const [state, setState] = useState<AppState>(loadStateFromLS());

    return (
        <AppContext.Provider value={{state: state, emit: createEmitter(setState)}}>
            <ThemeProvider theme="light">
                <ChunkBoundary>
                    <Suspense fallback={null}>
                        <KeyboardNavigationProvider>
                            <Routes>
                                <Route path="/" element={<Login />} />

                                <Route element={<AuthWrapper />}>
                                    <Route path="/home" element={<HomePage />} />
                                    <Route path="/orders" element={<OrdersPage />} />
                                    <Route path="/search" element={<SearchPage />} />
                                    <Route path="/search-details" element={<SearchPageDetails />} />
                                    <Route path="/clients" element={<ClientsPage />} />
                                    <Route path="/crosses" element={<CrossesPage />} />
                                    <Route path="/call-ws" element={<CallWSPage />} />
                                    <Route
                                        path="/settings"
                                        element={
                                            <PermissionGate
                                                roles={['superadmin', 'supervisor']}
                                                redirectTo="/home"
                                            >
                                                <SettingsPage />
                                            </PermissionGate>
                                        }
                                    />
                                    <Route path="/settings" element={<SettingsPage />} />
                                    <Route path="/reports" element={<ReportPage />} />
                                    <Route path="/suggest" element={<SuggestPage />} />
                                </Route>
                            </Routes>
                        </KeyboardNavigationProvider>
                    </Suspense>
                </ChunkBoundary>
            </ThemeProvider>
        </AppContext.Provider>
    );
};

export default App;
